import { Box } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Fragment } from "react";
import VaccinationListing from "./VaccinationListing";
import AddOtherVaccinationTab from "./AddOtherVaccinationTab";
import AddRabiesVaccinationTab from "./AddRabiesVaccinationTab";
import ChipTabs from "../../../components/ChipsTabs";
import VaccinesIcon from "@mui/icons-material/Vaccines";

export default function AddVaccinationForm() {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "vaccinations",
  });


  const tabContent = [
    <AddRabiesVaccinationTab append={append} fields={fields} />,
    <AddOtherVaccinationTab append={append} />,
  ];
  const tabLabels = ["Rabies", "Other"];
  const icons = [<VaccinesIcon />, <VaccinesIcon />];
  const tabTestIds = [
    "appointment.finish-meeting.vaccination.tab.rabies",
    "appointment.finish-meeting.vaccination.tab.other",
  ];

  function handleRemoveVaccination(index) {
    remove(index);
  }

  return (
    <Fragment>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <ChipTabs
          lsKey={"VACCINATION_LS_KEY"}
          icons={icons}
          tabContent={tabContent}
          tabLabels={tabLabels}
          tabTestIds={tabTestIds}
          wrapperMaxWidth="88vw"
        />
      </Box>

      {fields.length > 0 && (
        <Box data-testid="appointment.finish-meeting.vaccination.list">
          {fields.map((vaccination, index) => (
            <VaccinationListing
              key={index}
              vaccination={vaccination}
              handleRemoveVaccination={handleRemoveVaccination}
              index={index}
            />
          ))}
        </Box>
      )}
    </Fragment>
  );
}
